import { render } from "./FormatSubscript.vue?vue&type=template&id=07f72bf0"
import script from "./FormatSubscript.vue?vue&type=script&lang=js"
export * from "./FormatSubscript.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatSubscript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f72bf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f72bf0', __exports__)) {
    api.reload('07f72bf0', __exports__)
  }
  
  module.hot.accept("./FormatSubscript.vue?vue&type=template&id=07f72bf0", () => {
    api.rerender('07f72bf0', render)
  })

}


export default __exports__